export default __webpack_public_path__ + "bea27dc.png";